module.exports = __webpack_public_path__ + "img/bg.0d5298bc.png";